/**
 * 주어진 값이 null이거나 undefined인지 확인합니다.
 *
 * null이거나 undefined일 경우 true, 아닐 경우 false를 반환합니다.
 */
export const isNil = <T>(x: T | null | undefined): x is null | undefined => {
  return x == null;
};
